<template>
  <modal name="contract-purchaser" height="auto" width="825px" :scrollable="true" :shiftY="0.2" >
      <div class="close">
        <img class="hover_btn" src="../../assets/icons/close.svg" @click="$modal.hide('contract-purchaser')"  alt="">
      </div>
      <div class="modal-form">
        <div class="platform">
          <h4 class="title">Выберите вариант</h4>
        </div>
        <div class="platform p">
          <div class="table">
            <table class="worker-table">
            <tr>
              <th></th>
              <th>Цена за шт. руб.</th>
              <th>Остаток</th>
              <th>Цвет</th>
              <th>Размер</th>
              <th>Мой заказ</th>
              <th width="120px">Сумма, руб.</th>
              <th width="50px">

              </th>
            </tr>
            <tr v-for="(item, idx) in items" :key="idx" :class="{active: item.order >= 1}">
              <td><img class="photo" :src="item.photo" alt=""></td>
              <td> <div class="green text-right">{{item.price | currency}}</div></td>
              <td>{{item.pcs}}</td>
              <td>{{item.color}}</td>
              <td>{{item.size}}</td>
              <td width="40px"><app-chevron-counter v-model="item.count" @keyup="()=>{select(); checked[idx] = true  }"/></td>
              <td class="black text-right">
                {{item.price * item.count | currency}}
                <div class="inf">
                  <img v-if="item.verif" src="../../assets/icons/verification.svg" alt="">
                  <img v-if="item.packages" src="../../assets/icons/package.svg" alt="">
                </div>
              </td>
              <td>
                <app-checkbox v-model="checked[idx]" @change="select()" white table/>
              </td>
            </tr>
          </table>
          </div>
        </div>

        <div class="bottom-platform">
          <div class="platform h">
            <h4 class="grey">
              Итоговая сумма по позиции: <b>{{sum | currency}} ₽</b>
            </h4>
          </div>
          <div class="btn">
            <button @click="addCheckedBasket()">Добавить в заказ</button>
          </div>
        </div>

      </div>
  </modal>
</template>

<script>
import AppChevronCounter from "@/components/app-chevron-counter";
import AppCheckbox from "@/components/app-checkbox";

export default {
  name: "place-in-order-modal",
  components: {
    AppChevronCounter,
    AppCheckbox
  },
  data: ()=> ({
    checked: [],
    items: [],
    sum: 0
  }),
  methods: {
    open(items){
      this.checked = [];
      this.items = [];
      this.sum = 0;
      let color = '';
      let size = '';
      for (let key in items) {
        color = '';
        size = '';
        for(let key1 in items[key].attributes) {
          if (items[key].attributes[key1].attribute.name == 'Цвет' || items[key].attributes[key1].attribute.name == 'Цвет.') {
              color = items[key].attributes[key1].value.value;
          }
          if (items[key].attributes[key1].attribute.name == 'Размер' || items[key].attributes[key1].attribute.name == 'Размер обуви' || items[key].attributes[key1].attribute.name == 'размер обуви') {
             size = items[key].attributes[key1].value.value;
          }
        }
        this.items.push({
            photo: items[key].image != null ? items[key].image.image : '',
            price: items[key].price_opt,
            pcs: items[key].quantity,
            id: items[key].id,
            size: size,
            color: color,
            count: 1
        });
      }
      this.$modal.show('contract-purchaser');
    },
    select() {
      let sum = 0;
      for (let key in this.checked) {
        if (this.checked[key]) {
          sum = sum + (this.items[key].count * this.items[key].price);
        }
      }
      this.sum = sum;
    },
    addCheckedBasket() {
      let products = [];
      for (let key in this.checked) {
        if (this.checked[key]) {
          products.push({id: this.items[key].id, count: this.items[key].count});
        }
      }
      if (products.length > 0) {
        this.$http.post( '/add-group-products',{
          token: localStorage.getItem('token'),
          products: products
        }).then(({data}) => {
          if (data.success) {
            this.$modal.hide('contract-purchaser')
            this.$toast.success('Товары добавлены в форму заказа!');
          }
        })
      } else {
        this.$toast.warning('Товары не выбраны!');
      }
    }
  },
  watch: {
    chacked: function (val) {
        console.log(val);
    }
  }
}
</script>
<style>
 .vm--modal{
   background-color: unset !important;
   box-shadow: unset !important;
 }
</style>
<style scoped lang="scss">
.table{
  border-collapse: collapse;
  width: 100%;
  background: #fff;
  border: 1px #EEF0F3 solid;
  border-radius: 5px;
  margin-bottom: unset;
  th, td {
    .green{
      color: #2CB181;
    }
    &.black{
      color: black;
      width: 150px;
      font-weight: 600;
    }
    .inf{
      margin-left: auto;
      img{
        margin-left: 5px;
      }
    }
    flex-wrap: wrap;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    padding: 7px 14px;
    height: 40px;
    text-align: left;
  }
  th {
    color: #2D3137;
  }
  td{
    input{
      width: 40px;
      background: #FFFFFF;
      border: 1px solid #EEF0F3;
      border-radius: 4px;
      height: 30px;
      &:focus{
        border: 1px solid #2CB181;
      }
    }
  }
  tr {
    color: #7A818F;
    &.active{
      background: #E7FFF0;
      input{
        border: 1px solid #2CB181;
      }
    }
  }
  img{
    &.photo{
      height: 40px;
      width: 40px;
    }
  }
}
.progress-bar-container {
  width: 140px;
  margin: 0px auto;
}
.platform{
  width: 100%;
  padding: 16px;
  background: #FFFFFF;
  box-shadow: 0px 0px 3px #E5E5EA;
  border-radius: 4px;
  margin-bottom: 6px;

  &.p{
    padding: 0;
  }

  &.h{
    height: 50px;
    margin: 0 5px 0 0;

  }

}

.bottom-platform{
  display: flex;
  align-items: center;
}

.btn{
  width: 35%;
  padding: 0;
  button{
    width: 100%;
    height: 50px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    background: #2CB181;
    border-radius: 4px;
    border: none;
  }
}
.modal-form {
  background-color: unset !important;
  padding: 30px;
}
.input-block {
  margin-bottom: 15px;
}
h4{
  font-style: normal;
  font-weight: 500  ;
  font-size: 16px;
  line-height: 19px;
  margin: 0;

  &.grey{
    color: #7A818F;

    & b {
      color: #2D3137;
    }
  }
}
input{
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
  padding-left: 10px;
  width: 100%;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  &.about{
    height: 117px;
  }
  &:disabled{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #7A818F;
    background: #EEF0F3;
  }
}
</style>
